import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { contractVariables } from './Utils/contractVariables';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import mammoth from 'mammoth';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const profileFilter = chooseProfileFilter();
    
    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/contract-drafts/save`,
        endpointGetById: `${endpointBackend}gci/contract-drafts/getById`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        urlGoBack: `/gci/contract-drafts/list`,
        pathView: `/gci/contract-drafts/view`
    }

    const labels = {
        labelTitleAdd: "Nova Minuta de Contrato",
        labelTitleEdit: "Editar Minuta de Contrato",
        labelTitleView: 'Visualizar Minuta de Contrato'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'file',
                    type: 'fileS3',
                    label: 'Arquivo',
                    validations: {
                        required: true,
                        validContractDraft: true
                    },
                    columnSize: 12,
                    extensionAccept: '.docx',
                    uploadPath: 'contract-drafts'
                }
            ],
            customValidators: {
                validContractDraft: (value) => {
                    if (!value) return undefined;

                    return new Promise(async (resolve) => {
                        try {
                            const response = await fetch(value);
                            const arrayBuffer = await response.arrayBuffer();
                            const { value: fileContent } = await mammoth.extractRawText({ arrayBuffer });

                            const validVariables = Object.values(contractVariables);
                            const foundInFile = [...fileContent.matchAll(/\{([^}]+)\}/g)].map(m => m[1]);
                            const invalidVariables = [...new Set(foundInFile)].filter(v => !validVariables.includes(v));

                            if (invalidVariables.length > 0) {
                                resolve(`^Variável inválida encontrada no arquivo: ${invalidVariables.map(v => `{${v}}`).join(', ')}`);
                            } else {
                                resolve(undefined);
                            }
                        } catch (err) {
                            console.error('[validContractDraft]', err);
                            resolve('^Erro ao validar o arquivo. Tente novamente.');
                        }
                    });
                }
            },
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
